export const getRefreshTokenFromStorage = (key: string): string | null => {
  try {
    if (globalThis.window === undefined) return null;
    return localStorage.getItem(key);
  } catch (_: unknown) {
    return null;
  }
};
